import { useQuery } from "@tanstack/react-query";
import { searchEntities } from "../../services/entities";
import { searchUsers } from "../../services/users";
import { useTranslation } from "react-i18next";

type UseGoStarListingParams = {
  tabValue: number;
  page: number;
  nationality?: {
    label: string;
    value: string;
  } | null;
  country?: {
    label: string;
    value: string;
  } | null;
  gender?: {
    label: string;
    value: string;
  } | null;
  persona?: {
    label: string;
    value: string;
  } | null;
  roleTab: number;
};

const LIMIT = 14;

const useGoStarListing = ({
  tabValue,
  page,
  nationality,
  country,
  gender,
  persona,
  roleTab,
}: UseGoStarListingParams) => {
  const { i18n } = useTranslation();

  const fetchGoStarData = () => {
    const verificationStatus = tabValue === 1 ? "VERIFIED" : "";
    const isTrending = tabValue === 0;

    let role;
    if (persona) {
      role = persona.value.toUpperCase();
    } else {
      role = roleTab === 0 ? "PLAYER" : roleTab === 1 ? "COACH,AGENT,SCOUT,OTHER" : "";
    }

    if (roleTab === 2) {
      return searchEntities(
        LIMIT,
        page,
        "",
        country?.value,
        nationality?.value,
        verificationStatus === "VERIFIED",
        isTrending
      );
    }

    return searchUsers(
      LIMIT,
      page,
      "",
      country?.value,
      nationality?.value,
      gender?.value || "",
      verificationStatus,
      role,
      isTrending
    );
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ["GoStar", i18n.language, tabValue, page, nationality, gender, country, persona, roleTab],
    queryFn: fetchGoStarData,
  });

  return { goStarData: data, isGoStarDataLoading: isLoading, isGoStarDataHasError: error };
};

export default useGoStarListing;
